import { style, media } from 'typestyle'
import { important } from 'csx'
export const pl12smi = style(media({ maxWidth: 576 }, { paddingLeft: important('12px') }))
